// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_event_kind_enum */
var FermentationEventKindEnum;
(function (FermentationEventKindEnum) {
    FermentationEventKindEnum["NOTE"] = "NOTE";
    FermentationEventKindEnum["INCIDENT"] = "INCIDENT";
})(FermentationEventKindEnum || (FermentationEventKindEnum = {}));
;
export default FermentationEventKindEnum;
/** Zod schema for fermentation_event_kind_enum */
export const fermentationEventKindEnum = z.nativeEnum(FermentationEventKindEnum);
//# sourceMappingURL=FermentationEventKindEnum.js.map